import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="specific--oas-veranstaltung"
export default class extends Controller {
  static targets = ["disziplinSelectWrapper", "stilpruefungFeld", "stilpruefungFeldWrapper", "istVerbandsmitgliedCheckbox"]
  static values = {
    typIdsFuerDisziplin: Array,
    regionalverbandMitglieder: Array,
  }

  // Disziplinen nur anzeigen, wenn der Veranstaltungstyp Reitturnier ist
  setDisziplinVisibility(event) {
    const selectedTyp = parseInt(event.target.value)
    if (this.typIdsFuerDisziplinValue.includes(selectedTyp)) {
      this.disziplinSelectWrapperTarget.classList.remove("d-none")
    } else {
      this.disziplinSelectWrapperTarget.classList.add("d-none")
      this.disziplinSelectWrapperTarget.querySelector("select").tomselect.clear()
    }
  }

  // Stillprüfungsfelder zurücksetzen, wenn Stilprüfungen deaktiviert werden
  setStilpruefungenFelder(event) {
    const stilpruefungenChecked = event.target.checked
    if (stilpruefungenChecked) {
      this.stilpruefungFeldWrapperTarget.classList.remove("d-none")
    } else {
      this.stilpruefungFeldWrapperTarget.classList.add("d-none")
      this.stilpruefungFeldTargets.forEach((feld) => (feld.value = 0))
    }
  }

  // Checkbox "Ist Verbandsmitglied" je nach Veranstalter setzen
  setIstVerbandsmitglied(event) {
    const selectedVeranstalter = parseInt(event.target.value)
    if (this.regionalverbandMitgliederValue.includes(selectedVeranstalter)) {
      this.istVerbandsmitgliedCheckboxTarget.checked = true
    } else {
      this.istVerbandsmitgliedCheckboxTarget.checked = false
    }
  }
}
